<template>
    <div>
        <template v-if="wholesaler === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Active Orders ({{active_count}})</h1>
                <!-- <router-link to="/addShop" class="btn btn-primary float-right active"> Add New Shop</router-link> -->
                <div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
            </div>
            <div class="modal fade" id="getOrderReason" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body login-mobilizer text-left p-4">
                                    <div class="moblizer-account-detail">
                                        <div class="alert alert-danger" v-if="errorMessage!==''">{{errorMessage}}</div>
                                        <label class="label block-label"> Reason </label>
                                        <div class="form-group mb-2">
                                            <textarea v-model="orderReason" class="form-control"  ></textarea>
                                        </div>
                                        <div class="row normal-ib-space mt-3">
                                            <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                            <div class="col"> <button  class="btn btn-primary active" @click="updateOrderStatus()"> Submit </button> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
            <div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
					<table id="ordersTable" class="table">
                        <thead>
                            <tr>
                                <td>Sr.</td>
                                <td>Order ID</td>
                                <td>Order Date</td>
                                <td>Shop Name</td>
                                <td>Amount</td>
                                <td>Discount</td>
                                <td>Net Amount</td>
                                <td>Status</td>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div>
				<!-- <div class="tab-pane fade" id="inactive" role="tabpanel" aria-labelledby="inactive-tab">
					<table id="ordersTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Payment Engine</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div> -->
				
			</div>
        </template>
        <template v-else-if="wholesaler === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="wholesaler === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                wholesaler: null,
                ordersTable : null,
                dtActive : null,
                active_count : 0,
                errorMessage:'',
                orderReason: null,
                order_status: null,
                order_id : 0
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('wholesaler').then(result => {
                this.wholesaler = result.wholesaler;
            }).then(result => {
                if(this.wholesaler == true){
                    this.activeOrders();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            activeOrders(){
                var that = this;
                that.ordersTable = $('#ordersTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listOrdersDatatable",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records"
                    },
                    deferRender: true,
                    columns: [
                        
                        {render: function(data,type,full,row){
                            var rowNo = row.row+1+(row.settings.oAjaxData.start);
                            return rowNo;
                        }},
                        {data: 'id'},
                        {render: function(data,type,full,row){
                            return moment(full.order_date).format('MMM D, YYYY');
                        }},
                        {data: 'shop_name'},
                        {data: 'total_amount'},
                        {data: 'total_discount'},
                        {data: 'net_amount'},
                        {render: function(data,type,full,row){
                            if(full.status == "PENDING") {
                                return `<select class="form-control custom-select" id="orderStatusOnchange${full['id']}" onchange="VueComponents.orderComponent.methods.changeOrderStatus(${full['id']})">\
                                   <option value="PENDING">Pending</option>\
                                   <option value="DELIVERED">Delivered</option>\
                                   <option value="REJECTED">Rejected</option>\
                                   <option value="CANCELLED">Cancelled</option>\
                                   </select>`
                            } else {
                                return full.status
                            }
                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/orderDetails/'+full['order_id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Order Details" class="action edit"><i class="fas fa-eye"></i></a>';
                        }}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 8 ]
                    }],
                    "initComplete": (settings, json) => { 
                        this.active_count = json.recordsTotal; 
                        this.$Progress.finish();
                    },

                });
                $('#search_active').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        that.ordersTable.search(this.value).draw();
                    }
                });
            },
           deleteShop(id){
               var that = this;
               gThat.$Progress.start();
               swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this shop!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get("/api/softDeleteShop/"+id)
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.status == 200){
                                    gThat.$Progress.finish();
                                    gThat.ordersTable.ajax.reload( json => {
                                        gThat.active_count = json.recordsTotal;
                                    }, false);
                                    gThat.showAlertBox('success','Shop deleted successfully.');
                                }else{
                                    gThat.showToastBox('error','System is not responding! Please try again later.');
                                }
                            }else{
                                gThat.$Progress.fail();
                                gThat.showAlertBox('error','System is not responding! Please try again later.');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            gThat.$Progress.fail();
                            gThat.showAlertBox('error','System is not responding! Please try again later.');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        gThat.$Progress.finish();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                });
                
           },
           changeOrderStatus(id) {
                gThat.$Progress.start();
                gThat.order_id=id;
                gThat.order_status=$(`#orderStatusOnchange${id}`).val();
                if(gThat.order_status=='REJECTED' || gThat.order_status=='CANCELLED'){
                    $('#getOrderReason').modal('show');      
                }else{
                    gThat.orderReason = null;
                    this.updateOrderStatus(false);
                }
            },
            updateOrderStatus(reason=true){
                if(gThat.orderReason==null && reason){
                    gThat.errorMessage='Please provide reason!';
                    return false;
                }
                var data = {
                    'order_id' : gThat.order_id,
                    'status' : gThat.order_status,
                    'reject_reason' : gThat.orderReason
                };
                axios.post('/api/updateOrderStatus',data)
                .then((response) => {
                    console.log(response);
                    if(response.status == 200){
                        if(response.data.code == 200){
                            gThat.showToastBox('success','Order updated successfully!');
                            gThat.ordersTable.draw();
                            gThat.$Progress.finish();
                            $('#getOrderReason').modal('hide'); 
                        } else {
                            gThat.showAlertBox('error','There is some problem');
                        }
                    }else{
                        gThat.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    gThat.$Progress.fail();
                    gThat.showAlertBox('error','There is some problem');
                });
            },   
        },
    }
</script>
